import { HTTPClient } from '../utils/request'

export default {
  get: () => HTTPClient.get(`/type_vehicles`),
  store: ({ payload }) =>
    HTTPClient.post(`/type_vehicles/`, payload)
}
